export default __webpack_public_path__ + "static/media/wl-mbl.424dc3f2.png";